import React, { useState , useEffect } from 'react';
import axios from 'axios';
import '../Search/Search.css';
import EmployeeTwoWheeler from './EmployeeTwoWheeler';
import { useInput } from '../Context';

const TwoWheelerForm = () => {
  const { inputValue, handleSearch, twoWheelerResults } = useInput();
  const [searchTerm, setSearchTerm] = useState('');
  // const [searchResults, setSearchResults] = useState([]);
  const [isSearchBarActive, setIsSearchBarActive] = useState(true);
  const [editingData, setEditingData] = useState(null); // Track the row being edited
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formMode, setFormMode] = useState(null);
  const [records, setRecords] = useState([]);

  const handleToggleForm = () => {
    setIsFormOpen((prev) => !prev); // Toggle the form state
  };

  useEffect(() => {
    // Fetch all two-wheeler records from the backend
    const fetchRecords = async () => {
      try {
        const response = await axios.get("https://api.assetview.warrantyindia.com/api/twowheelerrecords");
        setRecords(response.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    fetchRecords();
  }, []);

  const handleDownloadPDF = (filename) => {
    const baseURL = 'https://api.assetview.warrantyindia.com/api/uploads'; // Replace with your API base URL
    window.open(`${baseURL}/${filename}`, '_blank');
  };

  // Handle search when the user types
  // const handleSearch = async (term) => {
  //   if (term) {
  //     try {
  //       const response = await axios.get(`https://localhost:7001/api/search-twowheeler?q=${term}`);
  //       setSearchResults(response.data);  // Update search results with the response data
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       setSearchResults([]);  // Clear search results on error
  //     }
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  // Handle input change and automatically search
  const handleInputChange = (e) => {
    const term = e.target.value;
    handleSearch(term);  // Trigger search for both employees and two-wheelers
  };


  const handleViewClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('view');   // Set mode to 'view'
  };

  // Handle the "Edit" button click
  const handleEditClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('edit');   // Set mode to 'edit'
  };

  // Handle form input change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditingData({ ...editingData, [name]: value });
  };

  // Handle form submit to save the edited data
  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Create a FormData object to handle file and text fields
      const formData = new FormData();
  
      // Append form fields to FormData
      formData.append("vechical_no", editingData.vechical_no || "");
      formData.append("date_of_purchase", editingData.date_of_purchase || "");
      formData.append("particulars", editingData.particulars || "");
      formData.append("used_by", editingData.used_by || "");
      formData.append("original_cost", editingData.original_cost || "");
      formData.append("remark", editingData.remark || "");
      formData.append("transfer_to", editingData.transfer_to || "");
      formData.append("transfer_date", editingData.transfer_date || "");
      formData.append("reporting_manager", editingData.reporting_manager || "");
  
      // Append files (if new files are selected)
      if (editingData.rc_uploade && editingData.rc_uploade instanceof File) {
        formData.append("rc_uploade", editingData.rc_uploade);
      }
      if (editingData.insurance_uploade && editingData.insurance_uploade instanceof File) {
        formData.append("insurance_uploade", editingData.insurance_uploade);
      }
  
      // Make the API request with FormData
      const response = await axios.put(
        `https://api.assetview.warrantyindia.com/api/updatevechical/${editingData.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      alert("Details updated successfully");
      setEditingData(null); // Close the form after submission
      handleSearch(inputValue); // Refresh the search results
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Failed to update details. Please try again.");
    }
  };
  
  


  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Offset timezone difference
    return d.toISOString().slice(0, 10); // Get 'YYYY-MM-DD' format
  };


  const formatDateToDDMMYYYY = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Adjust for timezone difference
  
    const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with 0 if necessary
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with 0 if necessary
    const year = d.getFullYear(); // Get full year
  
    return `${day}/${month}/${year}`;
  };

  return (
    
    <>
  {/* <form action="https://localhost:7001/uploadCsv" method="POST" enctype="multipart/form-data">
    <input type="file" name="file" accept=".csv" required />
    <button type="submit">Upload Excel</button>
  </form> */}

    <input
        type="text"
        placeholder="Search by Employee Name or Email"
        className="search-bar"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsSearchBarActive(true)}
        onBlur={() => inputValue === '' && setIsSearchBarActive(true)}  // Reset the position if the search term is empty
        style={{display:'none'}}
      />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', cursor: 'pointer' , marginTop:'60px' }}>
      
        <h2 style={{ color: 'red' }}>VEHICLE</h2>
        {/* Conditionally render + or - icon based on isFormOpen */}
        {isFormOpen ? (
          <i
            // className="fa-solid fa-minus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        ) : (
          <i
            // className="fa-solid fa-plus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        )}
      </div>
      <div>
      {isFormOpen && <EmployeeTwoWheeler />}
      </div>
      <div className="search-results">
  {twoWheelerResults.length > 0 ? (
    <table border={5} className="result-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ backgroundColor: '#f1f1f1', textAlign: 'left' }}>
        <th style={{ padding: '10px', width: '150px' }}>Vehical No.</th>
          <th style={{ padding: '10px', width: '150px' }}>Date of Purchase</th>
          <th style={{ padding: '10px', width: '150px' }}>Particulars</th>
          <th style={{ padding: '10px', width: '150px' }}>Used By</th>
          <th style={{ padding: '10px', width: '150px' }}>Original Cost</th>
          <th style={{ padding: '10px', width: '150px' }}>Transfer To</th>
          <th style={{ padding: '10px', width: '150px' }}>Transfer Date</th>
          <th style={{ padding: '10px', width: '150px' }}>Reporting Manager</th>
          <th style={{ padding: '10px', width: '150px' }}>Remark</th>
          <th style={{ padding: '10px', width: '150px' }}>RC FILE</th>
          <th style={{ padding: '10px', width: '150px' }}>INSURANCE FILE</th>
          <th style={{ padding: '10px', width: '150px' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {twoWheelerResults.map((result, index) => (
          <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '10px', width: '150px' }}>{result.vechical_no || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>
              {result.date_of_purchase ? formatDateToDDMMYYYY(result.date_of_purchase) : ''}
            </td>
            <td style={{ padding: '10px', width: '150px' }}>{result.particulars || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.used_by || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.original_cost || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.transfer_to || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.transfer_date ? formatDateToDDMMYYYY(result.transfer_date) : ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.reporting_manager || ''}</td>
            
            <td style={{ padding: '10px', width: '150px' }}>{result.remark || ''}</td>
            <th style={{ padding: '10px', width: '150px' }}>{result.rc_uploade ? (
                <button
                  onClick={() => handleDownloadPDF(result.rc_uploade)}
                  className="view-pdf-btn"
                  style={{ padding: '5px', fontSize: '14px' }}
                >
                  View PDF
                </button>
              ) : (
                'No PDF'
              )}</th>

<th style={{ padding: '10px', width: '150px' }}>{result.insurance_uploade ? (
                <button
                  onClick={() => handleDownloadPDF(result.insurance_uploade)}
                  className="view-pdf-btn"
                  style={{ padding: '5px', fontSize: '14px' }}
                >
                  View PDF
                </button>
              ) : (
                'No PDF'
              )}</th>
            <td style={{ padding: '10px', width: '150px', display: 'flex', gap: '10px',flexDirection:'column' }}>
              <button onClick={() => handleViewClick(result)} style={{ fontSize: '15px' }}>View</button>
              <button onClick={() => handleEditClick(result)} style={{ fontSize: '15px' }}>Edit</button>
              <button onClick={handleToggleForm} style={{ fontSize: '15px' }}>Add New</button>
            </td>
            
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <button style={{ padding: '10px', background: 'green', color: 'white', border: 'none', cursor: 'pointer' }} onClick={handleToggleForm}>
        Create Vehicle Data
      </button>
    </div>
  )}
</div>


      {/* Editing form */}
      {editingData && (
  <div className="edit-form-popup">
    <div className="edit-form">
      <h3>Edit Two-Wheeler Details</h3>
      <form onSubmit={handleFormSubmit} className="edit-form-container" encType="multipart/form-data">

      <div className="form-field">
          <label>Vehical No:</label>
          <input
            type="text"
            name="vechical_no"
            value={editingData.vechical_no}
            onChange={handleFormChange}
          />
        </div>

        <div className="form-field">
          <label>Date of Purchase:</label>
          <input
            type="date"
            name="date_of_purchase"
            value={formatDateToYYYYMMDD(editingData.date_of_purchase)}
            onChange={handleFormChange}
          />
        </div>
        <div className="form-field">
          <label>Particulars:</label>
          <input
            type="text"
            name="particulars"
            value={editingData.particulars}
            onChange={handleFormChange}
          />
        </div>
        <div className="form-field">
          <label>Used By:</label>
          <input
            type="text"
            name="used_by"
            value={editingData.used_by}
            onChange={handleFormChange}
          />
        </div>
        <div className="form-field">
          <label>Original Cost:</label>
          <input
            type="text"
            name="original_cost"
            value={editingData.original_cost}
            onChange={handleFormChange}
          />
        </div>
        <div className="form-field">
          <label>Remark:</label>
          <input
            type="text"
            name="remark"
            value={editingData.remark}
            onChange={handleFormChange}
          />
        </div>
        <div className="form-field">
          <label>Transfer To:</label>
          <select
            name="transfer_to"
            value={editingData.transfer_to}
            onChange={handleFormChange}
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        {editingData.transfer_to === "Yes" && (
          <>
            <div className="form-field">
              <label>Transfer Date:</label>
              <input
                type="date"
                name="transfer_date"
                value={formatDateToYYYYMMDD(editingData.transfer_date)}
                onChange={handleFormChange}
              />
            </div>
            <div className="form-field">
              <label>Reporting Manager:</label>
              <input
                type="text"
                name="reporting_manager"
                value={editingData.reporting_manager}
                onChange={handleFormChange}
              />
            </div>
          </>
        )}
        <div className="form-field">
          <label>Upload RC PDF:</label>
          <input
            type="file"
            name="rc_uploade"
            accept="application/pdf"
            onChange={(e) =>
              setEditingData({ ...editingData, rc_uploade: e.target.files[0] })
            }
          />
          {editingData.rc_uploade && (
            <a
              href={`https://api.assetview.warrantyindia.com/api/uploads/${editingData.rc_uploade}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "10px", textDecoration: "underline" }}
            >
              View Current RC PDF
            </a>
          )}
        </div>
        <div className="form-field">
          <label>Upload Insurance PDF:</label>
          <input
            type="file"
            name="insurance_uploade"
            accept="application/pdf"
            onChange={(e) =>
              setEditingData({ ...editingData, insurance_uploade: e.target.files[0] })
            }
          />
          {editingData.insurance_uploade && (
            <a
              href={`https://api.assetview.warrantyindia.com/api/uploads/${editingData.insurance_uploade}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "10px", textDecoration: "underline" }}
            >
              View Current Insurance PDF
            </a>
          )}
        </div>
        {formMode === "edit" ? <button type="submit">Save Changes</button> : null}
        <button type="button" onClick={() => setEditingData(null)}>Cancel</button>
      </form>
    </div>
  </div>
)}


    </>
  );
};

export default TwoWheelerForm;
